import './nuevaTablaDark.css'
import { useState } from 'react';
import ComponenteTablaDark from './ComponenteTablaDark/ComponenteTablaDark';
import ReactPaginate from "react-paginate";
import { MultiSelect } from "react-multi-select-component";
import Calendar from "react-calendar";
import dark from '../../../images/iconosPanelIzq/logo_dark.svg'
import { ThemeContext } from "../../../context/Theme";
import { useContext, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function NuevaTablaDark({
  updatedList,
  denuncias,
  fastList,
  isCalendar,
  cookies,
  setIsCalendar,
  ampSinLeer,
  estados,
  codigos,
  setInfo,
  sinFiltros,
  itemOffset,
  handlePageClick,
  pageCount,
  info,
  pendingInfo,
  setPendingInfo,
  handleFiltrar,
  handleVaciar,
  onChange,
  optionsTipoStro,
  responsabilidadChoques,
  responsabilidadRoboTotal,
  responsabilidadRoboParcial,
  responsabilidadRoboParcialInsp,
  responsabilidadIncendioTotal,
  responsabilidadIncendioParcial,
  responsabilidadDanioParcial,
  responsabilidadDanioTotal,
  responsabilidadInput,
  optionsCarga,
  optionsChoque,
  optionsContractuales,
  sicobeOptions,
  optionsPrioridad,
  optionsVencimiento,
  optionsCalendar,
  handleChange1,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  pendingStartDate,
  setPendingStartDate,
  pendingEndDate,
  setPendingEndDate,
  isInRange,
  handleClick,
  exportToExcel,
  rangoBusqueda,
  handleCambiarRango,
  isFetchingExtra,
}) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const headerRowRef = useRef(null);
    const [tipoFiltro, setTipoFiltro] = useState('todos');

    const filteredList = tipoFiltro === 'transito'
        ? updatedList.filter(d => d.tipoStro === 'ACCIDENTE DE TRANSITO')
        : tipoFiltro === 'contractuales'
            ? updatedList.filter(d => d.tipoStro !== 'ACCIDENTE DE TRANSITO')
            : updatedList;

    return (
        <main className="mainTablaDark">
            <div className='headerTablaDarkContainer' style={{ justifyContent: 'flex-end' }}>
                <div className='d-flex align-items-center' style={{ gap: '13px' }}>
                    <button onClick={toggleTheme} className='ultimoIconoPanelIzqStroDark' title='Switch Mode' style={{ margin: 0 }}>
                        <i className="bi bi-moon-fill" style={{ lineHeight: 1, fontSize: '20px' }}></i>
                    </button>
                    <Link to='/solicitudes' className='botonTablaHeaderDark center' style={{ textDecoration: 'none' }}>
                        <i className="bi bi-file-earmark-text me-2"></i>RECLAMOS
                    </Link>
                    {cookies?.user?.titulo === 'admin' ? (
                        <Link to='/capturas' className='botonTablaHeaderDark center' style={{ textDecoration: 'none' }}>
                            <i className="bi bi-camera me-2"></i>CAPTURAS
                        </Link>
                    ) : null}
                    <button className='botonCargaHeaderDark center'>
                        <i className="bi bi-plus-circle me-2"></i>CARGA
                    </button>
                    <button className='botonTablaHeaderDark center'>
                        <i className="bi bi-table me-2"></i>TABLA
                    </button>
                    {cookies?.user?.area === 'admin' ? (
                        <Link to='/ajustes' className='botonCargaHeaderDark center' style={{ textDecoration: 'none', width: '38px', height: '38px', padding: 0, borderRadius: '12px' }}>
                            <i className='bi bi-gear-fill'></i>
                        </Link>
                    ) : null}
                </div>
            </div>
            <section className='contenedorTablaFiltroDark'>
                <div style={{ width: '80%' }}>
                    <div className='contenedorTablaDark'>
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                            {/* Shadcn-style table header bar with toggle */}
                            <div className="shadcn-table-header-bar">
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <div className="input-icon-containerDark">
                                        <i className="bi bi-search input-iconDark"></i>
                                        <input
                                            className="busquedaGeneralDark"
                                            value={pendingInfo.buscarGeneral2}
                                            type="text"
                                            placeholder="BUSCAR"
                                            onChange={(e) => setPendingInfo((prevState) => ({ ...prevState, buscarGeneral2: e.target.value, }))}
                                            onKeyDown={(e) => { if (e.key === 'Enter') handleFiltrar(); }}
                                        />
                                    </div>
                                    <div className="shadcn-table-header-info">
                                        <span className="shadcn-table-title">Siniestros/Denuncias</span>
                                        <span className="shadcn-table-subtitle">{filteredList.length} registros</span>
                                    </div>
                                </div>
                                <div className="shadcn-tipo-toggle">
                                    <button
                                        type="button"
                                        className={`shadcn-tipo-btn ${tipoFiltro === 'todos' ? 'active' : ''}`}
                                        onClick={() => setTipoFiltro('todos')}
                                    >
                                        TODOS
                                    </button>
                                    <button
                                        type="button"
                                        className={`shadcn-tipo-btn ${tipoFiltro === 'transito' ? 'active active-transito' : ''}`}
                                        onClick={() => setTipoFiltro('transito')}
                                    >
                                        ACCIDENTES DE TRÁNSITO
                                    </button>
                                    <button
                                        type="button"
                                        className={`shadcn-tipo-btn ${tipoFiltro === 'contractuales' ? 'active active-contractuales' : ''}`}
                                        onClick={() => setTipoFiltro('contractuales')}
                                    >
                                        CONTRACTUALES
                                    </button>
                                </div>
                            </div>
                            <table className="tablaFija">
                                <thead className='tablaHeaderTablaDarkContainer'>
                                    <tr ref={headerRowRef}>
                                        <th className='headerTablaDark'>NRO STRO</th>
                                        <th className='headerTablaDark'>NRO DEN</th>
                                        <th className='headerTablaDark'>PZA</th>
                                        <th className='headerTablaDark'>DOM</th>
                                        <th className='headerTablaDark'>F.RECEP</th>
                                        <th className='headerTablaDark'>F.STRO</th>
                                        <th className='headerTablaDark'>F.REC RECIB</th>
                                        <th className='headerTablaDark'>F.VTO</th>
                                        <th className='headerTablaDark'>PRIORIDAD</th>
                                        <th className='headerTablaDark'>ASIGNADO</th>
                                        <th className='headerTablaDark'>ESTADO</th>
                                        <th className='headerTablaDark'>TIPO STRO</th>
                                        <th className='col-icon'></th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="tablaBodyDarkContainer my-scrollbar">
                                <table className="tablaFija">
                                    <tbody>
                                        {filteredList.length > 0 ? (
                                            filteredList.slice(itemOffset, Number(itemOffset + 200)).map((d) => (
                                                <ComponenteTablaDark
                                                    amp={ampSinLeer}
                                                    updatedList={updatedList}
                                                    estados={estados}
                                                    stro={d}
                                                    key={d.id}
                                                />
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={13}>
                                                    <div className='center py-5 d-flex flex-column align-items-center justify-content-center'>
                                                        {isFetchingExtra ? (
                                                            <div className='spinner-border text-success' role='status'>
                                                                <span className='visually-hidden'>Cargando...</span>
                                                            </div>
                                                        ) : rangoBusqueda === 'todos' && sinFiltros ? (
                                                            <h4 className='text-muted text-center' style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 500 }}>
                                                                Filtrar para mostrar resultados
                                                            </h4>
                                                        ) : sinFiltros ? (
                                                            <div className='spinner-border text-success' role='status'>
                                                                <span className='visually-hidden'>Cargando...</span>
                                                            </div>
                                                        ) : (
                                                            <h4 className='text-muted text-center' style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 500 }}>
                                                                Sin Resultados
                                                            </h4>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <section className="d-flex justify-content-between align-items-center" style={{ marginTop: '20px' }}>
                        <div className="d-flex paginateTablaDark">
                            <h6>Cantidad total: {filteredList.length}</h6>
                            <h6 className="ps-4">Cargados:{" "}{filteredList.filter((d) => d.nroStro !== null).length}</h6>
                            <h6 className="ps-4">Duplicados:{" "}{filteredList.filter((d) => d.estados.includes(204)).length}</h6>
                            <h6 className="ps-4">Sin Leer: {filteredList.filter((d) => d.estados.includes(200)).length}</h6>
                        </div>
                        {isCalendar == 3 && startDate ? (
                            <button className="btn btn-sm btn-primary" onClick={exportToExcel}>
                                Exportar Excel
                            </button>
                        ) : null}
                        <ReactPaginate
                            containerClassName={"customDark-paginate"}
                            pageClassName={"customDark-page"}
                            pageLinkClassName={"customDark-page-link"}
                            activeClassName={"active"}
                            previousClassName={"customDark-prev"}
                            nextClassName={"customDark-next"}
                            breakLabel="..."
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            marginPagesDisplayed={1}
                            pageCount={pageCount}
                            renderOnZeroPageCount={null}
                        />
                    </section>
                </div>
                <section className='contenedorFiltroDark'>
                    <div className='search-mode-toggle-wrapper'>
                        <div className='search-mode-toggle'>
                            <button
                                type='button'
                                className={`search-mode-toggle-option ${rangoBusqueda === '2meses' ? 'active' : ''}`}
                                onClick={() => handleCambiarRango('2meses')}
                            >
                                Últimos 2 meses
                            </button>
                            <button
                                type='button'
                                className={`search-mode-toggle-option ${rangoBusqueda === 'todos' ? 'active' : ''}`}
                                onClick={() => handleCambiarRango('todos')}
                            >
                                Todo el historial
                            </button>
                        </div>
                    </div>
                    <div className='filter-actions-wrapper'>
                        <button type="button" className='btn-filter-action btn-filtrar' onClick={handleFiltrar}>
                            <i className='bi bi-funnel-fill me-2'></i>
                            FILTRAR
                        </button>
                        <button type="button" className='btn-filter-action btn-vaciar' onClick={handleVaciar}>
                            <i className='bi bi-arrow-counterclockwise me-2'></i>
                            VACIAR
                        </button>
                    </div>
                    <div className="filter-row">
                        <div className="filtroTablaDark w-100">
                            <input
                                className="btnBusquedaDark ps-3"
                                type="text"
                                value={pendingInfo.poliza}
                                placeholder="POLIZA"
                                onChange={(e) =>
                                    setPendingInfo((prevState) => ({
                                        ...prevState,
                                        poliza: e.target.value,
                                    }))
                                }
                                onKeyDown={(e) => { if (e.key === 'Enter') handleFiltrar(); }}
                            />
                        </div>
                        <div className="filtroTablaDark w-100">
                            <input
                                className="btnBusquedaDark ps-3"
                                type="text"
                                placeholder="FECHA STRO"
                                disabled
                            />
                        </div>
                        <div className="filtroTablaDark w-100">
                            <input
                                className="btnBusquedaDark ps-3"
                                type="text"
                                placeholder="CODIGO PAS"
                                value={pendingInfo.codp}
                                onChange={(e) =>
                                    setPendingInfo((prevState) => ({
                                        ...prevState,
                                        codp: e.target.value,
                                    }))
                                }
                                onKeyDown={(e) => { if (e.key === 'Enter') handleFiltrar(); }}
                            />
                        </div>
                    </div>
                    <div className="filter-row">
                        <div className="filtroTablaDark w-100">
                            <input
                                className="btnBusquedaDark ps-3"
                                type="text"
                                value={pendingInfo.nroStro}
                                placeholder="NRO STRO"
                                onChange={(e) =>
                                    setPendingInfo((prevState) => ({
                                        ...prevState,
                                        nroStro: e.target.value,
                                    }))
                                }
                                onKeyDown={(e) => { if (e.key === 'Enter') handleFiltrar(); }}
                            />
                        </div>
                        <div className="filtroTablaDark w-100">
                            <input
                                className="btnBusquedaDark ps-3"
                                type="text"
                                value={pendingInfo.dominio}
                                placeholder="DOMINIO"
                                onChange={(e) =>
                                    setPendingInfo((prevState) => ({
                                        ...prevState,
                                        dominio: e.target.value,
                                    }))
                                }
                                onKeyDown={(e) => { if (e.key === 'Enter') handleFiltrar(); }}
                            />
                        </div>
                    </div>
                    <div className="filter-row">
                        <div className="filtroTablaDark">
                            <input
                                className="btnBusquedaDark ps-3"
                                type="text"
                                placeholder="DOMINIO 3ro"
                                value={pendingInfo.dominio3ro || ''}
                                onChange={(e) =>
                                    setPendingInfo((prevState) => ({
                                        ...prevState,
                                        dominio3ro: e.target.value,
                                    }))
                                }
                                onKeyDown={(e) => { if (e.key === 'Enter') handleFiltrar(); }}
                            />
                        </div>
                        <MultiSelect
                            disabled={cookies.user.id === 107}
                            className="w-100"
                            options={optionsTipoStro}
                            value={pendingInfo.tipoStro}
                            valueRenderer={(selected, _options) => {
                                return selected.length
                                    ? selected.map(({ label }) => label)
                                    : "TIPO STRO";
                            }}
                            onChange={(e) => {
                                const includesContractual = e.some(opt => opt.value === 'CONTRACTUAL');
                                const wasContractualSelected = pendingInfo.tipoStro.some(opt => opt.value === 'CONTRACTUAL');
                                let newSelection = e;
                                if (includesContractual && !wasContractualSelected) {
                                    newSelection = optionsTipoStro.filter(opt => opt.value !== 'ACCIDENTE DE TRANSITO');
                                } else if (!includesContractual && wasContractualSelected) {
                                    newSelection = [];
                                }
                                setPendingInfo((prev) => ({
                                    ...prev,
                                    tipoStro: newSelection,
                                    estado: [],
                                    catStro: [],
                                }));
                            }}
                        />
                    </div>
                    <div className="filter-row">
                            {pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "ACCIDENTE DE TRANSITO" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadChoques}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "ROBO TOTAL" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadRoboTotal}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "ROBO PARCIAL" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadRoboParcial}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "ROBO PARCIAL INSP" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadRoboParcialInsp}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "INCENDIO TOTAL" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadIncendioTotal}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "INCENDIO PARCIAL" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadIncendioParcial}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "DAÑO TOTAL" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadDanioTotal}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : pendingInfo.tipoStro[0] && pendingInfo.tipoStro[0].value === "DAÑO PARCIAL" ? (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadDanioParcial}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            ) : (
                                <MultiSelect
                                    disabled={cookies.user.id === 107}
                                    className="w-100"
                                    options={responsabilidadInput}
                                    value={pendingInfo.catStro}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "RESPONSABILIDAD";
                                    }}
                                    onChange={(e) => {
                                        const value = e;
                                        let tipoStro = null;
                                        if (value[0]) {
                                            if (
                                                value[0].value === 320 ||
                                                value[0].value === 300 ||
                                                value[0].value === 200 ||
                                                value[0].value === 230 ||
                                                value[0].value === 233
                                            ) {
                                                tipoStro = "ACCIDENTE DE TRANSITO";
                                            } else if (value[0].value === 500) {
                                                tipoStro = "ROBO TOTAL";
                                            } else if (value[0].value === 400) {
                                                tipoStro = "ROBO PARCIAL";
                                            } else if (
                                                value[0].value === 401 ||
                                                value[0].value === 402 ||
                                                value[0].value === 403 ||
                                                value[0].value === 550 ||
                                                value[0].value === 551
                                            ) {
                                                tipoStro = "ROBO PARCIAL INSP";
                                            } else if (value[0].value === 600) {
                                                tipoStro = "INCENDIO PARCIAL";
                                            } else if (value[0].value === 900) {
                                                tipoStro = "DAÑO TOTAL";
                                            } else if (value[0].value === 800) {
                                                tipoStro = "DAÑO PARCIAL";
                                            }
                                        }
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            catStro: e,
                                            estado: [],
                                            tipoStro: value[0]
                                                ? [{ value: tipoStro, label: tipoStro }]
                                                : pendingInfo.tipoStro,
                                        }));
                                    }}
                                />
                            )}

                            {cookies.user.id === 107 ? (
                                <MultiSelect
                                    className="w-100"
                                    options={estados
                                        .filter((estado) => [311, 302].includes(estado.id))
                                        .map((estado) => ({
                                            label: estado.nombre,
                                            value: estado.id
                                        }))
                                    }
                                    value={pendingInfo.estado}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "ESTADO";
                                    }}
                                    onChange={(e) => {
                                        if (e.some(option => option.value === 'separator')) return;
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            estado: e,
                                        }));
                                    }}
                                />
                            ) : (
                                <MultiSelect
                                    className="w-100"
                                    options={
                                        pendingInfo.tipoStro.length > 0 ?
                                            [
                                                ...estados
                                                    .filter((estado) => {
                                                        const a = codigos.filter((option) =>
                                                            pendingInfo.tipoStro.some((tipo) => tipo.value === option.tipoStro)
                                                        );
                                                        if (a.length > 0) {
                                                            return a.some((item) => {
                                                                const estadosPermitidos = item.estados.split(',').map(Number);
                                                                return estadosPermitidos.includes(estado.id);
                                                            });
                                                        }
                                                        return false;
                                                    })
                                                    .map((estado) => ({
                                                        label: estado.nombre,
                                                        value: estado.id
                                                    })),
                                                ...estados
                                                    .filter((estado) => [200, 201, 203].includes(estado.id))
                                                    .map((estado) => ({
                                                        label: estado.nombre,
                                                        value: estado.id
                                                    }))
                                            ]
                                            : estados
                                                .filter((estado) => [200, 201, 203].includes(estado.id))
                                                .map((estado) => ({
                                                    label: estado.nombre,
                                                    value: estado.id
                                                }))
                                    }
                                    value={pendingInfo.estado}
                                    valueRenderer={(selected, _options) => {
                                        return selected.length
                                            ? selected.map(({ label }) => label)
                                            : "ESTADO";
                                    }}
                                    onChange={(e) => {
                                        if (e.some(option => option.value === 'separator')) return;
                                        setPendingInfo((prevState) => ({
                                            ...prevState,
                                            estado: e,
                                        }));
                                    }}
                                />
                            )}
                    </div>
                    <div className="filter-row">
                        <MultiSelect
                            disabled={cookies.user.id === 107}
                            className="w-100"
                            options={
                                cookies.user.depto === "cargas"
                                    ? optionsCarga
                                    : cookies.user.depto === "choques"
                                        ? optionsChoque
                                        : cookies.user.depto === "contractuales"
                                            ? optionsContractuales
                                            : optionsCarga
                            }
                            value={pendingInfo.asignado}
                            valueRenderer={(selected, _options) => {
                                return selected.length
                                    ? selected.map(({ label }) => label)
                                    : "ASIGNADO A";
                            }}
                            onChange={(e) => {
                                setPendingInfo((prevState) => ({
                                    ...prevState,
                                    asignado: e,
                                }));
                            }}
                        />
                        <MultiSelect
                            disabled={cookies.user.id === 107}
                            className="w-100"
                            options={sicobeOptions}
                            value={pendingInfo.sicobe}
                            valueRenderer={(selected, _options) => {
                                return selected.length
                                    ? selected.map(({ label }) => label)
                                    : "CBT SICOBE";
                            }}
                            onChange={(e) => {
                                setPendingInfo((prevState) => ({
                                    ...prevState,
                                    sicobe: e,
                                }));
                            }}
                        />
                    </div>
                    <div className="filter-row">
                        <MultiSelect
                            disabled={cookies.user.id === 107}
                            className="w-100"
                            options={optionsPrioridad}
                            value={pendingInfo.prioridad}
                            valueRenderer={(selected, _options) => {
                                return selected.length
                                    ? selected.map(({ label }) => label)
                                    : "PRIORIDAD";
                            }}
                            onChange={(e) => {
                                setPendingInfo((prevState) => ({
                                    ...prevState,
                                    prioridad: e,
                                }));
                            }}
                        />
                        <MultiSelect
                            disabled={cookies.user.id === 107}
                            className="w-100"
                            options={optionsVencimiento}
                            value={pendingInfo.vencimiento}
                            valueRenderer={(selected, _options) => {
                                return selected.length
                                    ? selected.map(({ label }) => label)
                                    : "VENCIMIENTO";
                            }}
                            onChange={(e) => {
                                setPendingInfo((prevState) => ({
                                    ...prevState,
                                    vencimiento: e,
                                }));
                            }}
                        />
                    </div>
                    <hr style={{ color: 'white' }} />
                    <h5 className="center text-white mb-2">
                        {isCalendar == 3 ? 'Fecha Enviado a Cotizar' : isCalendar == 2 ? 'Filtrar Fecha Reclamo Recibido' : isCalendar == 1 ? 'Filtrar Fecha Vencimiento' : 'Filtrar Fecha Recepcion'}
                    </h5>
                    <div className="center">
                        <Calendar
                            onClickDay={handleClick}
                            tileClassName={({ date }) => (isInRange(date) ? 'in-range' : '')}
                            className="my-custom-calendarDark"
                        />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <select
                            value={isCalendar}
                            onChange={(e) => {
                                onChange(null);
                                setEndDate(null);
                                setStartDate(null);
                                setPendingStartDate(null);
                                setPendingEndDate(null);
                                handleChange1(e);
                            }}
                            className="select1 m-0"
                            style={{ height: "36px", width: "50%" }}
                        >
                            <option value="">Calendario</option>
                            {optionsCalendar.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={(e) => {
                                onChange(null);
                                setEndDate(null);
                                setStartDate(null);
                                setPendingStartDate(null);
                                setPendingEndDate(null);
                            }}
                        >
                            Quitar Filtro Fecha
                        </button>
                    </div>
                </section>
            </section>
        </main>
    );
}
